import { _ as __rest } from './_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { I as IdsFormField } from './form-field.js';
import '@ids/tools';
import { u as useId } from './use-id.js';
import { u as useFormField } from './use-form-field.js';
import { s as styleInject } from './style-inject.es.js';
import { I as IdsIcon } from './icon.js';

var css_248z = "/*\n** Voxel Foundation Formats\n*/\n:host {\n  width: 100%;\n}\n\n.ids-select {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  outline: none;\n}\n.ids-select:not(.ids-select--disabled) {\n  cursor: pointer;\n}\n.ids-select__icon {\n  pointer-events: none;\n  -webkit-transition: -webkit-transform 0.2s ease;\n  transition: -webkit-transform 0.2s ease;\n  transition: transform 0.2s ease;\n  transition: transform 0.2s ease, -webkit-transform 0.2s ease;\n}\n.ids-select__text {\n  color: var(--ids_color_action_neutral_variant);\n  font: var(--ids_textStyle_f02_s20_h26_wrg);\n  min-height: 1.625rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n}\n.ids-select--panel-open .ids-select__icon {\n  -webkit-transform: rotateX(180deg);\n          transform: rotateX(180deg);\n}\n.ids-select--no-label .ids-select__text {\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  padding: 0 var(--ids_spacing_2x);\n}\n\n.ids-select-options {\n  -webkit-box-shadow: 0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86, 80, 76, 0.24);\n          box-shadow: 0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86, 80, 76, 0.24);\n  margin-top: var(--ids_size_general_10x);\n  overflow-y: auto;\n  width: 100%;\n}\n.ids-select-options--no-label {\n  margin-top: var(--ids_size_general_5x);\n}\n.ids-select-options--top {\n  margin-bottom: var(--ids_size_general_28x);\n  margin-top: 0;\n}\n.ids-select-options--top.ids-select-options--no-label {\n  margin-bottom: var(--ids_size_general_10x);\n}";
styleInject(css_248z);

const IdsSelect = _a => {
  var {
      children,
      id: externalId,
      label,
      description,
      errorMessage,
      prefix,
      defaultValue,
      value: externalValue,
      onChange,
      onFocus,
      onBlur,
      className = '',
      formFieldProps,
      formMessageProps
    } = _a,
    props = __rest(_a, ["children", "id", "label", "description", "errorMessage", "prefix", "defaultValue", "value", "onChange", "onFocus", "onBlur", "className", "formFieldProps", "formMessageProps"]);
  const id = useId(externalId, 'ids-react-select');
  const ref = useRef();
  const {
    disabled,
    readOnly
  } = props;
  const {
    focus,
    handleBlur,
    handleFocus,
    handleChange,
    value
  } = useFormField({
    defaultValue,
    value: externalValue,
    onChange,
    onFocus,
    onBlur,
    disabled,
    readOnly
  });
  const invalid = focus === false && ref && !ref.current.checkValidity();
  return jsx(IdsFormField, Object.assign({
    htmlFor: id,
    label: label,
    focus: focus,
    prefix: prefix,
    suffix: jsx(IdsIcon, Object.assign({
      variant: "primary"
    }, {
      children: "seta_baixo"
    })),
    invalid: invalid,
    hasValue: Boolean(value),
    disabled: disabled,
    readOnly: readOnly,
    description: description,
    errorMessage: errorMessage,
    className: className
  }, formFieldProps, {
    formMessageProps: Object.assign({
      children: formMessageProps === null || formMessageProps === void 0 ? void 0 : formMessageProps.children
    }, formMessageProps)
  }, {
    children: jsx("select", Object.assign({
      "aria-invalid": invalid,
      className: "ids-native-select",
      id: id,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      ref: ref,
      value: value
    }, props, {
      children: children
    }))
  }));
};

export { IdsSelect as I };
//# sourceMappingURL=select.js.map
